<div class="base-notification">
  <div class="base-notification__wrapper" [ngClass]="wrapperClassName">
    <div class="base-notification__header">
      <div class="base-notification__header__title">
        <ng-content select="[header]"></ng-content>
      </div>
      <div class="base-notification__header__cta">
        <ng-content select="[cta]"></ng-content>
      </div>
    </div>
    <div class="base-notification__content" [ngClass]="contentClassName">
      <ng-content select="[content]"></ng-content>
    </div>
  </div>
</div>
